import React, { lazy } from 'react';
import { createRoute, createRouter } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';
import { authenticatedRoute } from './_authenticated';

// Import page components
import Login from 'components/login/Login';
import Lobby from 'components/lobby/Index';
import LobbyPage from 'components/lobby/Lobby';
import OrderPage from 'components/order/Index';
import OrderSummaryPage from 'components/order/Summary';
import SchedulePage from 'components/schedule/Index';
import MessageCenterPage from 'components/messagecenter/Index';
import HostBoothPage from 'components/hostbooth/Index';
import BoothPage from 'components/booth/Booth';
import BoothsPage from 'components/booth/Index';
import InstructionsPage from 'components/instructions/Index';
import SupportPage from 'components/support/Index';
import MeetingSchedulePage from 'components/meetingschedule/Index';
import AnnouncementsPage from 'components/announcements/Index';

// Lazy load ShowInfoPage
const ShowInfoPage = lazy(() => import('components/showinfo/Index'));

// Public route - Login
export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: Login,
});

// Authenticated routes
export const indexRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/',
  component: Lobby,
});

export const lobbyRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/lobby',
  component: LobbyPage,
});

export const hostBoothRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/host-booth',
  component: HostBoothPage,
});

export const orderRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/order',
  component: OrderPage,
});

export const orderSummaryRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/order-summary',
  component: OrderSummaryPage,
});

export const scheduleRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/schedule',
  component: SchedulePage,
});

export const messageCenterRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/message-center',
  component: MessageCenterPage,
});

export const boothsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/booths',
  component: BoothsPage,
});

export const boothRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/booth/$id',
  component: BoothPage,
});

export const meetingScheduleRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/meeting-schedule',
  component: MeetingSchedulePage,
});

export const instructionsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/instructions',
  component: InstructionsPage,
});

export const announcementsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/announcements',
  component: AnnouncementsPage,
});

export const showInfoRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/show-info',
  component: ShowInfoPage,
});

export const supportRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/support',
  component: SupportPage,
});

// Create the route tree
const routeTree = rootRoute.addChildren([
  loginRoute,
  authenticatedRoute.addChildren([
    indexRoute,
    lobbyRoute,
    hostBoothRoute,
    orderRoute,
    orderSummaryRoute,
    scheduleRoute,
    messageCenterRoute,
    boothsRoute,
    boothRoute,
    meetingScheduleRoute,
    instructionsRoute,
    announcementsRoute,
    showInfoRoute,
    supportRoute,
  ]),
]);

// Create the router instance
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent' as const,
});

// Register router for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
